export enum ECQRSApi{
    Read,
    Write
}